import { useCompanyConfig } from '@lib/config/hooks';
import { useEmbedContext } from '@lib/embed/providers/EmbedProvider';
import { transform } from '@lib/string-rewriter';
import { useMemo } from 'react';

interface UseCtaDeeplinkResult {
    href: string;
}

export const useCtaDeeplink = (originalUrl: string): UseCtaDeeplinkResult => {
    const { platform } = useEmbedContext();
    const { cta: ctaConfig } = useCompanyConfig();

    const resolvedHref = useMemo(() => {
        if (platform === 'web') {
            return null;
        }

        if (!ctaConfig.deeplinkRewriteRules) {
            return null;
        }

        const rule = ctaConfig.deeplinkRewriteRules[platform];
        if (rule) {
            return transform(originalUrl, rule);
        }
        return null;
    }, [platform, originalUrl, ctaConfig]);

    return {
        href: resolvedHref ?? originalUrl,
    };
};
